import React from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Danger-zone account deletion panel.
 *
 * Extracted verbatim from src/pages/Settings.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function DeleteAccountSection({ onRequestDelete }) {
  return (
    <section className="mt-6 rounded-2xl border border-[#F0C5C0] bg-[#FDF4F3] p-6">
      <h2 className="font-display text-xl font-bold text-[#B42318]">Delete my account</h2>
      <p className="mt-2 text-sm text-[#7A2A22] leading-6">
        This removes your profile from the directory, ends your sponsorship connections and
        anonymises your account. This cannot be undone. Deleting your account is always free.
      </p>
      <Button
        onClick={onRequestDelete}
        data-testid="delete-account-button"
        className="mt-4 bg-[#B42318] hover:bg-[#94180F] text-white"
      >
        <Trash2 className="w-4 h-4 mr-1.5" /> Delete my account
      </Button>
    </section>
  );
}
